import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { hashHistory } from 'react-router'
import { Link } from 'react-router'
import { Row, Col } from 'hljd'
import Header from './header'
import Left from './left'
import Right from './right'
import Store from './store'
import { Provider } from 'mobx-react'

class CustomerDetail extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()

    //显示编辑详情
    const visible = props.location.query.visible || ''
    this.store.setStoreData([
      { type: 'id', value: props.params.id },
      { type: 'customerVisible', value: visible ? true : false }
    ])

    //如果有reco_id 锚点跳转
    const record_id = props.location.query.record_id || ''
    if (record_id) {
      this.store.setStoreData([
        {
          type: 'callbackAfterGetCustomerList',
          value: () => {
            let anchorElement = document.getElementById(record_id)
            !!anchorElement && anchorElement.scrollIntoView()
          }
        }
      ])
    }
    if (visible || record_id) {
      hashHistory.replace(props.location.pathname)
    }
    this.store.getCustomerDetail()
  }
  componentDidMount() {
    this.store.getStaffList()
    this.store.getPropertyList()
    this.store.getCardList()
  }
  render() {
    const header = [
      <Link to="/localMerchant/newCustomer">客户管理</Link>,
      '客户详情'
    ]
    return (
      <Provider detailStore={this.store}>
        <HeaderView
          title="客户管理"
          header={header}
          contentStyle={{ backgroundColor: 'initial', padding: 0 }}
          // bodyStyle={{ padding: 0 }}
        >
          <Header store={this.store} />
          <Row>
            <Col span={10}>
              <Left id={this.props.params.id} store={this.store} />
            </Col>
            <Col span={14}>
              <Right id={this.props.params.id} store={this.store} />
            </Col>
          </Row>
        </HeaderView>
      </Provider>
    )
  }
}

export default CustomerDetail
